import {connect} from 'react-redux';
import {SetActiveTab, setActiveTabAction} from 'VideoAudioQC/QCTabs/Redux/QCTabsActions';
import {
    SetShowHotkeys,
    setShowHotkeysAction,
    SetShowSafeMargins,
    setShowSafeMarginsAction,
} from 'VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerActions';
import PlayerControlsContainer from './PlayerControlsContainer';
import {AccuratePlayerState} from '../AccuratePlayer/Redux/AccuratePlayerReducer';
import {QCTabsState} from '../QCTabs/Redux/QCTabsReducer';
import {TimelineRowType} from '../Timeline/TimelineTypes';
import {TimelineState} from '../Timeline/Redux/TimelineReducer';
import {
    selectNextPreviousMarkerAction,
    SelectNextPreviousMarker,
} from '../Timeline/Redux/TimelineActions';

interface StateProps {
    paused: boolean;
    volume: number;
    muted: boolean;
    showSafeMargins: boolean;
    activeTab: number;
    qcReportRowId: string;
    adBreaksRowId: string;
    markupRowId: string;
    selectedType: TimelineRowType;
}

export interface PlayerState {
    videoAudioQC: {
        accuratePlayer: AccuratePlayerState;
        qcTabs: QCTabsState;
    };
    timeline: {
        adBreaks: {
            rowId: string;
        };
        selectedMarker: TimelineState;
        qcReport: {
            rowId: string;
        };
        markup: {
            rowId: string;
        };
    };
}

export const mapState = (state: PlayerState): StateProps => {
    const {videoAudioQC, timeline} = state;
    const {accuratePlayer, qcTabs} = videoAudioQC;
    const {adBreaks, qcReport, markup} = timeline;
    const {selectedType} = timeline.selectedMarker;
    const {paused, volume, muted, showSafeMargins} = accuratePlayer;
    const {activeTab} = qcTabs;
    const qcReportRowId = qcReport.rowId;
    const adBreaksRowId = adBreaks.rowId;
    const markupRowId = markup.rowId;

    return {
        paused,
        volume,
        muted,
        showSafeMargins,
        activeTab,
        selectedType,
        qcReportRowId,
        adBreaksRowId,
        markupRowId,
    };
};

interface DispatchProps {
    selectNextPreviousMarker: SelectNextPreviousMarker;
    setShowHotkeys: SetShowHotkeys;
    setActiveTab: SetActiveTab;
    setShowSafeMargins: SetShowSafeMargins;
}

export const mapDispatch: DispatchProps = {
    selectNextPreviousMarker: selectNextPreviousMarkerAction,
    setShowHotkeys: setShowHotkeysAction,
    setActiveTab: setActiveTabAction,
    setShowSafeMargins: setShowSafeMarginsAction,
};

export default connect(mapState, mapDispatch)(PlayerControlsContainer);
